import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import useIsIPhone from "../../hooks/useIsIphone";

// assets
import prev from "../../assets/images/gold-previous.png";
import next from "../../assets/images/gold-next.png";

const MonthlyTotalReturns = (props) => {
  // console.log(props);
  const slider = React.useRef(null);
  const isIphone = useIsIPhone();
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  // settings for the react slider
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showSlider = screenSize < 900 && !isIphone;
  return (
    <section id="monthly-total-returns">
      {showSlider ? (
        <div>
          <div className="monthly-total-return-img-wrapper">
            <div className="main-padding">
              <h1 className="sub-header t-center">
                Monthly/Quarterly Total Returns
                <sup className="small-sup">3,4</sup>
              </h1>
            </div>
          </div>
          <div
            style={{ padding: "0 30px 30px", borderBottom: "1px solid black" }}
          >
            <h2 className="sub-header t-center">{props.class}</h2>
            <div className="my-carousel-container">
              {props.data?.["annual-return"] &&
                Array.isArray(props.data["annual-return"]) && (
                  <div className="custom-arrows-performance">
                    <div onClick={() => slider?.current?.slickPrev()}>
                      <img src={prev} alt="previous" />
                    </div>
                    <div onClick={() => slider?.current?.slickNext()}>
                      <img src={next} alt="next" />
                    </div>
                  </div>
                )}
            </div>
            <Slider ref={slider} {...settings}>
              {props.data != null ? (
                Array.isArray(props.data["annual-return"]) ? (
                  props.data["annual-return"].map((rPercent, i) => {
                    return (
                      <div>
                        <div className="t-center">
                          <h2 className="fw-5">{rPercent.year_no}</h2>
                        </div>
                        <table className="w-full mt-12" key={i}>
                          <tbody>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                JAN
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.jan_return_percent != null
                                  ? `${rPercent.jan_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                FEB
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.feb_return_percent != null
                                  ? `${rPercent.feb_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                MAR
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.mar_return_percent != null
                                  ? `${rPercent.mar_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                APR
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.apr_return_percent != null
                                  ? `${rPercent.apr_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                MAY
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.may_return_percent != null
                                  ? `${rPercent.may_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                JUN
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.jun_return_percent != null
                                  ? `${rPercent.jun_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                JUL
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.jul_return_percent != null
                                  ? `${rPercent.jul_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                AUG
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.aug_return_percent != null
                                  ? `${rPercent.aug_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                SEP
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.sep_return_percent != null
                                  ? `${rPercent.sep_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                OCT
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.oct_return_percent != null
                                  ? `${rPercent.oct_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                NOV
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.nov_return_percent != null
                                  ? `${rPercent.nov_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td style={{ border: "none", padding: "10px" }}>
                                DEC
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                }}
                              >
                                {rPercent.dec_return_percent != null
                                  ? `${rPercent.dec_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                            <tr style={{ background: "white", border: "none" }}>
                              <td
                                style={{
                                  border: "none",
                                  padding: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                YTD
                              </td>
                              <td
                                style={{
                                  border: "none",
                                  textAlign: "right",
                                  padding: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                {rPercent.ytd_return_percent != null
                                  ? `${rPercent.ytd_return_percent}%`
                                  : null}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })
                ) : (
                  <div>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr style={{ background: "white", border: "none" }}>
                          <td style={{ border: "none", padding: "10px" }}>
                            Q1
                          </td>
                          <td
                            style={{
                              border: "none",
                              textAlign: "right",
                              padding: "10px",
                            }}
                          >
                            {props.data["annual-return"].q1_return_percent !=
                            null
                              ? `${props.data["annual-return"].q1_return_percent}%`
                              : null}
                          </td>
                        </tr>
                        <tr style={{ background: "white", border: "none" }}>
                          <td style={{ border: "none", padding: "10px" }}>
                            Q2
                          </td>
                          <td
                            style={{
                              border: "none",
                              textAlign: "right",
                              padding: "10px",
                            }}
                          >
                            {props.data["annual-return"].q2_return_percent !=
                            null
                              ? `${props.data["annual-return"].q2_return_percent}%`
                              : null}
                          </td>
                        </tr>
                        <tr style={{ background: "white", border: "none" }}>
                          <td style={{ border: "none", padding: "10px" }}>
                            Q3
                          </td>
                          <td
                            style={{
                              border: "none",
                              textAlign: "right",
                              padding: "10px",
                            }}
                          >
                            {props.data["annual-return"].q3_return_percent !=
                            null
                              ? `${props.data["annual-return"].q3_return_percent}%`
                              : null}
                          </td>
                        </tr>
                        <tr style={{ background: "white", border: "none" }}>
                          <td style={{ border: "none", padding: "10px" }}>
                            Q4
                          </td>
                          <td
                            style={{
                              border: "none",
                              textAlign: "right",
                              padding: "10px",
                            }}
                          >
                            {props.data["annual-return"].q4_return_percent !=
                            null
                              ? `${props.data["annual-return"].q4_return_percent}%`
                              : null}
                          </td>
                        </tr>
                        <tr style={{ background: "white", border: "none" }}>
                          <td
                            style={{
                              border: "none",
                              padding: "10px",
                              fontWeight: "500",
                            }}
                          >
                            YTD
                          </td>
                          <td
                            style={{
                              border: "none",
                              textAlign: "right",
                              padding: "10px",
                              fontWeight: "500",
                            }}
                          >
                            {props.data["annual-return"].ytd_return_percent !=
                            null
                              ? `${props.data["annual-return"].ytd_return_percent}%`
                              : null}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )
              ) : (
                <div style={{ padding: "20px", textAlign: "center" }}>N/A</div>
              )}
            </Slider>
          </div>
          {props.class !== "Class I" ? (
            <div className="main-padding">
              <p
                style={{
                  fontWeight: "500",
                  marginBottom: "0",
                  marginTop: "0",
                }}
              >
                Note: Past performance is historical and not a guarantee of
                future results.
              </p>
              <p style={{ marginTop: "0" }}>
                * Does not assume payment of the maximum upfront sales charges
                at initial subscription for Class D, S and T shares. Payment of
                the upfront sales charge reduces returns.
              </p>
            </div>
          ) : null}
        </div>
      ) : (
        <div className="main-padding">
          <div class="main-margin">
            <div className="mb-10">
              <h1 className="sub-header">
                Monthly/Quarterly Total Returns
                <sup className="small-sup">3,4</sup>
              </h1>
            </div>
          </div>
          <div className="main-margin table-shadow-main">
            <div className="table-container">
              <table className="odtable-header">
                <thead>
                  <tr>
                    {props.class === "Class I" ? (
                      <th className="odtable-tableheader">{props.class}</th>
                    ) : (
                      <th className="odtable-tableheader">{props.class}*</th>
                    )}
                    <th className="odtable-tableheader">JAN</th>
                    <th className="odtable-tableheader">FEB</th>
                    <th className="odtable-tableheader">MAR</th>
                    <th className="odtable-tableheader">APR</th>
                    <th className="odtable-tableheader">MAY</th>
                    <th className="odtable-tableheader">JUN</th>
                    <th className="odtable-tableheader">JUL</th>
                    <th className="odtable-tableheader">AUG</th>
                    <th className="odtable-tableheader">SEP</th>
                    <th className="odtable-tableheader">OCT</th>
                    <th className="odtable-tableheader">NOV</th>
                    <th className="odtable-tableheader">DEC</th>
                    <th className="odtable-tableheader">YTD</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data != null ? (
                    Array.isArray(props.data["annual-return"]) ? (
                      props.data["annual-return"].map((rPercent, i) => {
                        return (
                          <tr key={i}>
                            <td className="fw-6">{rPercent.year_no}</td>
                            <td>
                              {rPercent.jan_return_percent != null
                                ? `${rPercent.jan_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.feb_return_percent != null
                                ? `${rPercent.feb_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.mar_return_percent != null
                                ? `${rPercent.mar_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.apr_return_percent != null
                                ? `${rPercent.apr_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.may_return_percent != null
                                ? `${rPercent.may_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.jun_return_percent != null
                                ? `${rPercent.jun_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.jul_return_percent != null
                                ? `${rPercent.jul_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.aug_return_percent != null
                                ? `${rPercent.aug_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.sep_return_percent != null
                                ? `${rPercent.sep_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.oct_return_percent != null
                                ? `${rPercent.oct_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.nov_return_percent != null
                                ? `${rPercent.nov_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.dec_return_percent != null
                                ? `${rPercent.dec_return_percent}%`
                                : null}
                            </td>
                            <td>
                              {rPercent.ytd_return_percent != null
                                ? `${rPercent.ytd_return_percent}%`
                                : null}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td className="fw-6">
                          {props.data["annual-return"].year_no}
                        </td>
                        <td>
                          {props.data["annual-return"].jan_return_percent !=
                          null
                            ? `${props.data["annual-return"].q1_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].feb_return_percent !=
                          null
                            ? `${props.data["annual-return"].q2_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].mar_return_percent !=
                          null
                            ? `${props.data["annual-return"].q3_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].apr_return_percent !=
                          null
                            ? `${props.data["annual-return"].q4_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].may_return_percent !=
                          null
                            ? `${props.data["annual-return"].may_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].jun_return_percent !=
                          null
                            ? `${props.data["annual-return"].jun_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].jul_return_percent !=
                          null
                            ? `${props.data["annual-return"].jul_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].aug_return_percent !=
                          null
                            ? `${props.data["annual-return"].aug_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].sep_return_percent !=
                          null
                            ? `${props.data["annual-return"].sep_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].oct_return_percent !=
                          null
                            ? `${props.data["annual-return"].oct_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].nov_return_percent !=
                          null
                            ? `${props.data["annual-return"].nov_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].dec_return_percent !=
                          null
                            ? `${props.data["annual-return"].dec_return_percent}%`
                            : null}
                        </td>
                        <td>
                          {props.data["annual-return"].ytd_return_percent !=
                          null
                            ? `${props.data["annual-return"].ytd_return_percent}%`
                            : null}
                        </td>
                      </tr>
                    )
                  ) : (
                    <div style={{ padding: "20px", textAlign: "center" }}>
                      N/A
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {props.class !== "Class I" ? (
            <div className="main-margin">
              <p
                style={{
                  marginTop: "35px",
                  fontWeight: "500",
                  marginBottom: "0",
                }}
              >
                Note: Past performance is historical and not a guarantee of
                future results.
              </p>
              {props.load !== "0.00" ? (
                <p style={{ marginTop: "0" }}>
                  * Does not assume payment of the maximum upfront sales charges
                  at initial subscription for Class D, S and T shares. Payment
                  of the upfront sales charge reduces returns.
                </p>
              ) : // <p style={{ marginTop: "0" }}>
              //   * Assumes payment of the full upfront {props.load}% selling
              //   commissions at initial subscription.
              // </p>
              null}
            </div>
          ) : null}
        </div>
      )}
    </section>
  );
};

export default MonthlyTotalReturns;
